// extracted by mini-css-extract-plugin
module.exports = {"dialog":"BillingTariffPlans_dialog__v1cLs"};